<template>
    <BreadCrumb PageTitle="Modifier une règle" />
    <EditRule />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditRule from "@/components/Rules/EditRule.vue";

export default defineComponent({
    name: "EditRulePage",
    components: {
        BreadCrumb,
        EditRule,
    },
});
</script>